import * as React from 'react';
import { connect } from 'react-redux';
import NewSettingPopup from '../common/NewSettingPopup';
import { Dispatch, Action } from 'redux';
import { AppStates } from '../../reducers/app';
import { ReflowableContentSettingState } from '../../reducers/ui/reflowableContentSetting';
import ReflowableContentSettingPanel from './ReflowableContentSettingPanel';
import ReflowableContentSNEPatternSelectPanel from './ReflowableContentSNEPatternSelectPanel';
import SettingPopupTabs from '../common/setting-popup-tabs/SettingPopupTabs';
import SettingPopupTabList from '../common/setting-popup-tabs/SettingPopupTabList';
import SettingPopupTab from '../common/setting-popup-tabs/SettingPopupTab';
import SettingPopupTabPanel from '../common/setting-popup-tabs/SettingPopupTabPanel';
import ReflowableToolIconButton from './ReflowableToolIconButton';
import { getBasePath } from '../../utils/browser';
import { zIndex } from '../../constants';
import ReflowableContentUIAction from '../../actions/ui/ReflowableContentUIAction';
import { SelectedReflowTabType } from '../../drawing/types';
import { DialogType } from '../common/SettingDialogContainer';

interface ReflowableContentSettingDialogProps {
  readonly setting: ReflowableContentSettingState;
  readonly onClose: () => void;
  readonly setDialogType: (dialogType: DialogType) => void;
  readonly dispatch: Dispatch<Action>;
}

const tabStyle: React.CSSProperties = {
  width: '48px',
  height: '48px',
  minWidth: '48px',
  backgroundColor: 'rgba(0, 0, 0, 0)',
  marginLeft: '12px',
};

const handleOnClickTab = (
  selected: SelectedReflowTabType,
  event: React.MouseEvent,
  dispatch: Dispatch<Action>,
) => {
  event.stopPropagation();
  ReflowableContentUIAction.setSelected(selected, dispatch);
};

const contentsContainerStyle: React.CSSProperties = {
  maxHeight: '396px',
  minHeight: '190px',
  padding: 0,
};

const ReflowableContentSettingDialog: React.SFC<
  ReflowableContentSettingDialogProps
> = React.memo((props) => {
  const { onClose, dispatch, setting, setDialogType } = props;
  const baseDir = getBasePath();

  const settingPopupTabStyle: React.CSSProperties = {
    width: '71px',
    height: '80px',
    backgroundImage: `url('${baseDir}/images/setting-popup/setting-popup-inactive-tab-bg.png')`,
    backgroundSize: 'contain',
    margin: 0,
    border: 0,
    transform: 'translateX(2px)',
    zIndex: zIndex.settingPopupTab,
    paddingLeft: '5px',
  };

  const activeSettingPopupTabStyle: React.CSSProperties = {
    backgroundImage: `url('${baseDir}/images/setting-popup/setting-popup-active-tab-bg.png')`,
    paddingLeft: 0,
  };

  return (
    <SettingPopupTabs
      vertical={true}
      initialSelectedTabIndex={setting.selected === SelectedReflowTabType.Reflow ? 0 : 1}>
      <NewSettingPopup
        imgName={ setting.selected === SelectedReflowTabType.Reflow ?
          'text_reflow_setting' : 'text_bw_flip_setting' }
        title={setting.selected === SelectedReflowTabType.Reflow ? 'リフロー設定' : '白黒反転設定' }
        onClose={onClose}
        renderOutsideLeft={() => (
          <SettingPopupTabList style={{ flexDirection: 'column', marginTop: '67px' }}>
            <SettingPopupTab
              style={settingPopupTabStyle}
              selectedStyle={activeSettingPopupTabStyle}
              highlightStyle={activeSettingPopupTabStyle}
              onClick={ev => handleOnClickTab(SelectedReflowTabType.Reflow, ev, dispatch)}>
              <ReflowableToolIconButton
                title="リフロー設定"
                style={tabStyle}
                imagePath="images/tool-icons/new/reflow_setting/reflow_setting"
                />
            </SettingPopupTab>
            <SettingPopupTab
              style={settingPopupTabStyle}
              selectedStyle={activeSettingPopupTabStyle}
              highlightStyle={activeSettingPopupTabStyle}
              onClick={ev => handleOnClickTab(SelectedReflowTabType.SNE, ev, dispatch)}>
              <ReflowableToolIconButton title="白黒反転設定"
                style={tabStyle}
                imagePath="images/tool-icons/new/black_white_flip_setting/black_white_flip_setting"
                />
            </SettingPopupTab>
          </SettingPopupTabList>
        )} >
        <SettingPopupTabPanel style={contentsContainerStyle}>
          <ReflowableContentSettingPanel />
          <ReflowableContentSNEPatternSelectPanel  setDialogType={ setDialogType }/>
        </SettingPopupTabPanel>
      </NewSettingPopup>
    </ SettingPopupTabs>
  );
});

const mapStateToProps = (appStates: AppStates) => {
  return { setting: appStates.ui.reflowableContentSetting };
};

export default connect(mapStateToProps)(ReflowableContentSettingDialog);
